<template>
  <div class="view_page">
    <div class="page_head"></div>
    <div class="page_body">
      <div class="content">
        <div class="ct_img">
        <!--  <img
            src="../../../resource/img/WeChatbfaed0.png"
            alt
            style="width:100%;height:100%;border-radius: 10px 10px 0px 0px;"
          />-->
          <img
            :src="imageUrl+activitData.pic"
            alt
            style="max-height: 99%;border-radius: 10%;margin-top: 1%;"
          />
        </div>
        <div class="ct_text">
          <span style="font-size: 3vw;">商家名称:{{activitData.launchUser}}</span>
          <span style="font-size: 3vw;">活动名称:{{activitData.name}}</span>
          <span style="font-size: 3vw;color: rgba(90,90,90,1);margin-top: 1vw;">活动时间:{{activitData.startDate}} - {{activitData.endDate}}</span>
         <!-- <span style="font-size: 3vw;color: rgba(90,90,90,1);margin-top: 1vw;"> 支付时间:2010-06-12 11:11:11</span>-->
        </div>
        <div style="overflow: scroll;height: 45vh">
          <div class="bjcard" v-for="(item,index) in carList" :key="index">
            <div class="cardrowhead">
              <img
                src="../../../resource/img/qia.png"
                alt
                style="width: 3.9vw;height: 3vw;margin-right: 1vw;"
              />
              <span>{{item.name}}</span>
            </div>
            <div class="cardrowone">
              <table style="float:left;width:75%">
                <tr style="text-align: center">
                  <td style="width:10%">总数</td>
                  <td style="width:10%">已使用</td>
                  <td style="width:3%">剩余</td>
                </tr>
                <tr style="text-align: center">
                  <td style="width:10%">{{item.buyNum}}</td>
                  <td style="width:10%">{{item.useNum}}</td>
                  <td style="width:3%">{{item.buyNum - item.useNum}}</td>
                </tr>
              </table>
              <img v-if="item.status == 0"
                src="../../../resource/img/two-dime.png"
                alt
                style="width:10%;height:50%;margin-left: 5%;"
                @click="codeGenerate(item,index)"
              />
            </div>
            <div class="cardrowtwo" v-if="item.merchantExtendOrderUsedetailEntityList.length>0">
              <div class="cardrowhead">
                <img
                  src="../../../resource/img/shijian.png"
                  alt
                  style="width: 3.9vw;height: 3vw;margin-right: 1vw;"
                />
                <span>使用时间</span>
              </div>
              <div>
              <span v-for="(items,indexs) in item.merchantExtendOrderUsedetailEntityList" :key="indexs" style="font-size: 3vw;margin-right: 10vw;line-height: 15px;">
                {{items.useTime}}
              </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="Submission_page" v-show="isCollapse">
      <div class="smerm">
        <img
          src="../../../resource/img/gb.png"
          alt
          style="width:8%;height:8%;float:right"
          @click="closeEwm"
        />
        <p style="font-size:14px;font-weight:400">核销二维码</p>
        <div id="qrcode" style="width:33vw;display: flex;justify-content: center;margin-left: 15vw;"></div>
        <p
          style="color:rgba(247,193,39,1);font-size:13px;width:90%;margin-left:3%;"
        >生成二维码仅限提供给商家店铺员工 扫描验证消费使用哦~</p>
      </div>
    </div>
  </div>
</template>
<script>
  import {qrcanvas} from "qrcanvas";
  let timeId;
  export default {
    name: "MerTokerOrderUse",
    data() {
      return {
        isCollapse: false,
        urlParam: [],
        carList: [],
        ewmparam: [],
        activitData:{
          launchUser:"",
          name:"",
          startDate:null,
          endDate:null,
          pic:''
        },
        orderId:'',
        imageUrl: this.$common.URL,
        orderType:0
       // wxappUrl:this.$common.wxappUrl,
      };
    },
    created() {

      let that = this;
      // 获取路由参数
      that.urlParam = that.$route.query;
      that.orderId = that.$route.query.orderId;
      that.activityId = that.$route.query.activityId;
      that.orderType = that.$route.query.orderType;
      //页面加载信息
      if(that.orderType == 0){
        that.pageload();
      }else{
        that.giftOrderList();
      }

      if(that.$common.activitydata!=""){
        that.activitData = that.$common.activitydata;
      }else{//获取对应的活动信息
        this.getActivityData(that.activityId);
      }

    },
    methods: {
      getActivityData: function(activityId){
        let that = this;
        that.$axios
          .post(
            "/merchant/api/activity/merchant-market-extend/activity-data",
            that.$qs.stringify({
              activityId: activityId,
            })
          )
          .then(response => {
            if (response.data.code == 1) {
              that.activitData = response.data.data;
            }
          })
          .catch(function (error) {
            //请求失败处理
            console.log(error);
          });
      },
      closeEwm: function () {
        let that = this;
        that.isCollapse = false;
        window.clearInterval(timeId);  //移除定时器
      },
      pageload: function () {
        let that = this;
        that.$axios
          .post(
            "/merchant/api/activity/merchant-market-product-order/list",
            that.$qs.stringify({
              orderId: this.orderId,
            })
          )
          .then(response => {
            if (response.data.code == 1) {
              that.carList = response.data.data;
            }
          })
          .catch(function (error) {
            //请求失败处理
            console.log(error);
          });
      },
      codeGenerate:function(item,index){
        let that = this;
        that.isCollapse = true;
        let url = this.URL+ "/wap.php?g=Wap&c=Storestaff&a=mrmf_market_use&orderId="+item.marketOrderId;
        let canvas1 = qrcanvas({
          data: decodeURIComponent(url), //分享链接（根据需求来）
          size: 100//二维码大小
        });
        document.getElementById("qrcode").innerHTML = "";
        document.getElementById("qrcode").appendChild(canvas1);

        //定时器进行判断是否核销成功
         timeId = setInterval(function() {
           that.$api.post({
             url: '/merchant/api/activity/merchant-market-product-order/use/check',
             data: {
               marketOrderId: item.marketOrderId
             }
           }).then(response => {
             let productOrder = response.data;

              if(productOrder!=null ){
                let useNum = productOrder.useNum || 0;
                if(parseInt(useNum)>item.useNum){
                  console.log("核销成功");
                  window.clearInterval(timeId);  //移除定时器
                  that.isCollapse = false;
                  if(that.orderType == 0){
                    that.pageload();
                  }else{
                    that.giftOrderList();
                  }
                  that.$message.success("核销成功");
                }
              }
           })
        }, 5000); //执行的定时器
      },
      giftOrderList:function () {
        let that = this;
        that.$axios
          .post(
            "/merchant/api/activity/merchant-market-product-order/gift/detail",
            that.$qs.stringify({
              marketOrderId: this.orderId,
            })
          )
          .then(response => {
            if (response.data.code == 1) {
              that.carList = response.data.data;
            }
          })
          .catch(function (error) {
            //请求失败处理
            console.log(error);
          });

      }
    },
    // 点击后拿到数据返回给下单地址
    beforeRouteLeave (to, from, next) {
      clearInterval(timeId);  //移除定时器
      next()//一定不要忘记写
    }
  };
</script>

<style scoped>
  .view_page {
    width: 100%;
    height: 100%;
    margin-top: 50px;
  }

  .page_head {
    width: 100%;
    height: 30vh;
    background-image: url("../../../resource/img/Nipic_12106414_20160922174257880038.png");
  }

  .page_body {
    width: 100%;
    height: 64vh;
    background: rgba(242, 242, 242, 1);
    display: flex;
    justify-content: center;
  }

  .content {
    width: 88%;
    height: 85vh;
    background: rgba(255, 255, 255, 1);
    border-radius: 20px 20px 20px 20px;
    position: relative;
    top: -40%;
  }

  .ct_img {
    width: 100%;
    height: 28%;
    justify-content: center;
    display: flex;
  }

  .ct_text {
    /* width: 50%; */
    height: 15%;
    text-align: left;
    margin-top: 5%;
    margin-left: 6%;
    display: flex;
    flex-direction: column;
  }

  .bjcard {
    display: flex;
    flex-direction: column;
    width: 90%;
    /*height: 28%;*/
    text-align: left;
    margin-left: 6%;
    border-bottom: 1px solid #e5e5e5;
    border-top: 1px solid #e5e5e5;
  }

  .cardrowhead {
    align-items: center;
    display: flex;
    margin-top: 2%;
  }

  .cardrowone {
    display: flex;
    align-items: center;
    width: 100%;
    height: 26%;
    margin-top: 1%;
  }

  .cardrowtwo {
    width: 100%;
    height: 40%;
    border-top: 0.3vw dashed dimgray;
    color: #bfbfbf;
    margin-top: 4vw;
  }

  .Submission_page {
    background: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    display: flex;
    justify-content: center;
  }

  .smerm {
    width: 66vw;
    height: 66vw;
    background-color: white;
    margin-top: 60%;
    display: block;
    text-align: center;
  }

  .cardrowone table > tr > td {
    font-size: 3.5vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/active/store/MerTokerOrderUse.vue